__turbopack_context__.v({
  "className": "ibm_plex_sans_9285b50b-module__JbErIq__className",
  "variable": "ibm_plex_sans_9285b50b-module__JbErIq__variable",
});
